export const plantasKeys = {
  plantas: ['plantas'] as const,
  listaPorBloco: (idExternoBloco: number) => [...plantasKeys.plantas, 'bloco', idExternoBloco] as const,
  detalhePlanta: (idExternoBloco: number, codigoPlanta: number) =>
    [...plantasKeys.listaPorBloco(idExternoBloco), 'planta', codigoPlanta] as const,
  disponivelParaSimulacao: (idExternoBloco: number, idExternoPlanta: number) =>
    [...plantasKeys.detalhePlanta(idExternoBloco, idExternoPlanta), 'disponivel-para-simulacao'] as const,
}
